module.exports = __webpack_public_path__ + "static/media/oberflex-ako-1200x2490.e10c62d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ako-1200x2490.jpg
// module id = 970
// module chunks = 37